import {NAVBAR_HEIGHT} from "base/config/measurements";

import {AppMenuItem} from ".";
import Grid from "@mui/material/Grid";
import MenuList from "@mui/material/MenuList";
import useTheme from "@mui/material/styles/useTheme";

const AppMenu = ({children = null, menuItems = []}) => {
    const theme = useTheme();

    const leftSideItems = menuItems.map((menuItem, index) => (
        <AppMenuItem
            key={index}
            text={menuItem.name}
            to={menuItem.to}
            resolvedPathName={menuItem.pathname}
            resolvedSecondPathName={menuItem.second_pathname || menuItem.pathname}
        />
    ));

    return (
        <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
                width: "100%",
                height: `${NAVBAR_HEIGHT}px`,
                borderTop: "1px solid #fff",
                borderBottom: `1px solid white`,
                p: 0,
            }}
        >
            <Grid
                item
                component="nav"
                sx={{
                    height: `100%`,
                }}
            >
                <MenuList
                    sx={{
                        display: "flex",
                        direction: "row",
                        height: `100%`,
                        p: 0,
                    }}
                >
                    {leftSideItems}
                </MenuList>
            </Grid>
            <Grid item sx={{pr: 2}}>
                {children}
            </Grid>
        </Grid>
    );
};

export default AppMenu;
